import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\AdminController::serpapi
 * @see app/Http/Controllers/AdminController.php:91
 * @route '/admin/settings/serpapi'
 */
export const serpapi = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: serpapi.url(options),
    method: 'post',
})

serpapi.definition = {
    methods: ["post"],
    url: '/admin/settings/serpapi',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AdminController::serpapi
 * @see app/Http/Controllers/AdminController.php:91
 * @route '/admin/settings/serpapi'
 */
serpapi.url = (options?: RouteQueryOptions) => {
    return serpapi.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AdminController::serpapi
 * @see app/Http/Controllers/AdminController.php:91
 * @route '/admin/settings/serpapi'
 */
serpapi.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: serpapi.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\AdminController::syncScholar
 * @see app/Http/Controllers/AdminController.php:121
 * @route '/admin/settings/sync-scholar'
 */
export const syncScholar = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: syncScholar.url(options),
    method: 'post',
})

syncScholar.definition = {
    methods: ["post"],
    url: '/admin/settings/sync-scholar',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AdminController::syncScholar
 * @see app/Http/Controllers/AdminController.php:121
 * @route '/admin/settings/sync-scholar'
 */
syncScholar.url = (options?: RouteQueryOptions) => {
    return syncScholar.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AdminController::syncScholar
 * @see app/Http/Controllers/AdminController.php:121
 * @route '/admin/settings/sync-scholar'
 */
syncScholar.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: syncScholar.url(options),
    method: 'post',
})
const settings = {
    serpapi: Object.assign(serpapi, serpapi),
syncScholar: Object.assign(syncScholar, syncScholar),
}

export default settings